import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar'
import { useTeamChange } from '@/hooks/use-team-change'
import { listTeamsQuery } from '@/queries/team.query'
import { Team } from '@/services/team.service'
import {
  selectActiveTeam,
  selectGetIsOwner,
  useAuthStore,
} from '@/stores/auth.store'
import { IconSteam } from '@tabler/icons-react'
import { useSuspenseQuery } from '@tanstack/react-query'
import { ChevronsUpDown, Plus } from 'lucide-react'

export function TeamSwitcher() {
  const { isMobile } = useSidebar()
  const { data: teams } = useSuspenseQuery(listTeamsQuery)
  const activeTeam = useAuthStore(selectActiveTeam)
  const getIsOwner = useAuthStore(selectGetIsOwner)
  const { changeTeam } = useTeamChange()

  function handleAddTeam() {
    // TODO: Implement add team
  }

  async function handleChangeTeam(team: Team) {
    if (activeTeam?.id === team.id) {
      return
    }
    await changeTeam(team)
  }

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size='lg'
              className='data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground'
            >
              <div className='flex items-center justify-center rounded-lg aspect-square size-8 bg-sidebar-primary text-sidebar-primary-foreground'>
                <IconSteam className='size-4' />
              </div>
              <div className='grid flex-1 text-sm leading-tight text-left'>
                <span className='font-semibold truncate'>
                  {activeTeam?.name}
                </span>
                <span className='text-xs truncate'>
                  {getIsOwner() ? 'Dono' : 'Atendente'}
                </span>
              </div>
              <ChevronsUpDown className='ml-auto' />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className='w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg'
            align='start'
            side={isMobile ? 'bottom' : 'right'}
            sideOffset={4}
          >
            <DropdownMenuLabel className='text-xs text-muted-foreground'>
              Equipes
            </DropdownMenuLabel>
            {teams.map((team, index) => (
              <DropdownMenuItem
                key={team.name}
                onClick={() => handleChangeTeam(team)}
                className='gap-2 p-2'
              >
                <div className='flex items-center justify-center border rounded-sm size-6'>
                  <IconSteam className='size-4 shrink-0' />
                </div>
                {team.name}
                <DropdownMenuShortcut>⌘{index + 1}</DropdownMenuShortcut>
              </DropdownMenuItem>
            ))}
            <DropdownMenuSeparator />
            <DropdownMenuItem className='gap-2 p-2'>
              <div className='flex items-center justify-center border rounded-md size-6 bg-background'>
                <Plus className='size-4' />
              </div>
              <div className='font-medium text-muted-foreground'>Add team</div>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
